export default __webpack_public_path__ + "static/media/41.33108144.jpeg";